import { configureStore } from '@reduxjs/toolkit'

import rootReducer from 'us_pcb_assembly/store/rootReducer'

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
})

export default store
